$(document).ready(function() {
  var reapplyAnimation = function(element, animationClass) {
    // Remove the class to reset the animation
    $(element).removeClass(animationClass);
    setTimeout(function() {
      // Re-add the class to trigger the animation
      $(element).addClass(animationClass);
    }, 50); // A slight delay ensures the class change is recognized
  };

  $('.blob').each(function() {
    var blobElement = this;
    new Waypoint({
      element: blobElement,
      handler: function(direction) {
        if (direction === 'down') {
          // Apply animations to the blob and image as before
          reapplyAnimation(blobElement, 'animated-fade-rotate');
          var relatedImage = $(blobElement).closest('.custom-image-text-section').find('.image-container img')[0];
          reapplyAnimation(relatedImage, 'animated-slide-rotate');

          // Now also target the text container for its animation
          var textContainer = $(blobElement).closest('.custom-image-text-section').find('#text-container')[0];
          reapplyAnimation(textContainer, 'animated-fade-in-slide-in-right');
        }
      },
      offset: '75%' // Trigger point
    });
  });
});


$(document).ready(function() {
  var reapplyAnimation = function(element, animationClass) {
    // Remove the class to reset the animation
    $(element).removeClass(animationClass);
    setTimeout(function() {
      // Re-add the class to trigger the animation
      $(element).addClass(animationClass);
    }, 50); // A slight delay ensures the class change is recognized
  };

  $('.blob').each(function() {
    var blobElement = this;
    new Waypoint({
      element: blobElement,
      handler: function(direction) {
        if (direction === 'down') {
          // Apply animations to the blob and image as before
          reapplyAnimation(blobElement, 'animated-fade-rotate');
          var relatedImage = $(blobElement).closest('.custom-image-text-section').find('.image-container-right img')[0];
          reapplyAnimation(relatedImage, 'animated-slide-rotate_from_right');

          // Now also target the text container for its animation
          var textContainer = $(blobElement).closest('.custom-image-text-section').find('#text-container-left')[0];
          reapplyAnimation(textContainer, 'animated-fade-in-slide-in-left');
        }
      },
      offset: '75%' // Trigger point
    });
  });
});



    
